import React, { createContext, useContext, useState, useEffect } from 'react';

export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'hi', label: 'हिंदी', flag: '🇮🇳' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' }
];

export const TRANSLATIONS = {
  en: {
    channels: 'Channels',
    epg: 'EPG Schedule',
    favorites: 'Favorites',
    playlists: 'Library Playlists',
    multiView: 'Multi-View (2x2)',
    singleView: 'Single Stream',
    searchChannels: 'Search channels...',
    allCategories: 'All Categories',
    boost: 'Gain Boost',
    eqMode: 'EQ Preset',
    normal: 'Normal (100%)',
    bassBoost: 'Bass Boost (160%)',
    vocalEnhancer: 'Vocal Enhancer',
    superBoost: '200% Super Boost',
    soundscape: 'Ambient Noise',
    rain: 'Rain Sounds',
    waves: 'Ocean Waves',
    off: 'Off',
    aspectRatio: 'Aspect Ratio',
    fit169: 'Fit 16:9',
    fillZoom: 'Fill/Zoom',
    stretch: 'Stretch',
    fit43: 'Fit 4:3',
    speed: 'Playback Speed',
    telemetry: 'Stream Diagnostics',
    voiceControl: 'AI Voice Control',
    voiceListening: 'Listening for commands...',
    voiceInstruction: 'Say "Switch to [Channel]" or "Bass Boost"',
    parentalPin: 'Parental PIN',
    enterPin: 'Enter 4-Digit PIN',
    pinLocked: 'Category Locked',
    unlock: 'Unlock Category',
    cloudResume: 'Resume Last Played',
    cloudResumePrompt: 'Pick up where you left off on another device?',
    resume: 'Resume Stream',
    dismiss: 'Dismiss',
    installApp: 'Install IPTV App',
    pwaPrompt: 'Install to Home Screen for fast native streaming',
    upgradePro: 'Upgrade to PRO',
    heroTitlePrefix: 'The Ultimate',
    heroTitleHighlight: 'IPTV Player',
    heroTitleSuffix: 'for Your Browser',
    heroTitleLine1: 'The Ultimate',
    heroTitleLine2: 'IPTV Player for Your Browser',
    heroSubtitle: 'Stream your M3U playlists instantly with zero installation. Experience cinematic fluidity, Web Audio EQ gain boosters, real-time telemetry HUD, and 2x2 multi-view grid streaming directly in your browser.',
    ctaOpenLibrary: 'OPEN YOUR LIBRARY',
    ctaStartStreaming: 'START STREAMING NOW',
    ctaExploreChannels: 'EXPLORE FREE CHANNELS',
    navFeatures: 'Features',
    navHowItWorks: 'How It Works',
    navFaq: 'FAQ',
    navGuides: 'Guides'
  },
  es: {
    channels: 'Canales',
    epg: 'Guía EPG',
    favorites: 'Favoritos',
    playlists: 'Listas Guardadas',
    multiView: 'Multivista (2x2)',
    singleView: 'Vista Única',
    searchChannels: 'Buscar canales...',
    allCategories: 'Todas las categorías',
    boost: 'Amplificador de Audio',
    eqMode: 'Ecualizador',
    normal: 'Normal (100%)',
    bassBoost: 'Bass Boost (160%)',
    vocalEnhancer: 'Mejorador Vocal',
    superBoost: '200% Súper Boost',
    soundscape: 'Sonidos Ambientales',
    rain: 'Lluvia',
    waves: 'Olas del Mar',
    off: 'Desactivado',
    aspectRatio: 'Relación de Aspecto',
    fit169: 'Ajustar 16:9',
    fillZoom: 'Rellenar/Zoom',
    stretch: 'Estirar',
    fit43: 'Ajustar 4:3',
    speed: 'Velocidad de Reproducción',
    telemetry: 'Diagnóstico de Transmisión',
    voiceControl: 'Control por Voz IA',
    voiceListening: 'Escuchando comandos...',
    voiceInstruction: 'Di "Cambiar a [Canal]" o "Bass Boost"',
    parentalPin: 'PIN Parental',
    enterPin: 'Ingrese PIN de 4 dígitos',
    pinLocked: 'Categoría Bloqueada',
    unlock: 'Desbloquear Categoría',
    cloudResume: 'Reanudar Último Canal',
    cloudResumePrompt: '¿Reanudar donde te quedaste en otro dispositivo?',
    resume: 'Reanudar Stream',
    dismiss: 'Descartar',
    installApp: 'Instalar Aplicación',
    pwaPrompt: 'Instala en la pantalla de inicio para una experiencia fluida',
    upgradePro: 'Mejorar a PRO',
    dailyLimitReached: 'Límite diario gratuito alcanzado (10 min)',
    heroTitlePrefix: 'El Definitivo',
    heroTitleHighlight: 'Reproductor IPTV',
    heroTitleSuffix: 'para Tu Navegador',
    heroTitleLine1: 'El Definitivo',
    heroTitleLine2: 'Reproductor IPTV para Tu Navegador',
    heroSubtitle: 'Transmita sus listas M3U al instante sin necesidad de instalación. Disfrute de fluidez cinematográfica, potenciadores de audio EQ, telemetría en tiempo real y vista múltiple 2x2 directamente en su navegador.',
    ctaOpenLibrary: 'ABRIR TU BIBLIOTECA',
    ctaStartStreaming: 'EMPEZAR A TRANSMITIR',
    ctaExploreChannels: 'EXPLORAR CANALES GRATIS',
    navFeatures: 'Funciones',
    navHowItWorks: 'Cómo Funciona',
    navFaq: 'Preguntas Frecuentes',
    navGuides: 'Guías'
  },
  hi: {
    channels: 'चैनल',
    epg: 'ईपीजी अनुसूची',
    favorites: 'पसंदीदा',
    playlists: 'लाइब्रेरी प्लेलिस्ट',
    multiView: 'मल्टी-व्यू (2x2)',
    singleView: 'सिंगल व्यू',
    searchChannels: 'चैनल खोजें...',
    allCategories: 'सभी श्रेणियां',
    boost: 'ऑडियो बूस्ट',
    eqMode: 'इक्वलाइज़र मोड',
    normal: 'सामान्य (100%)',
    bassBoost: 'बेस बूस्ट (160%)',
    vocalEnhancer: 'वोकल एन्हांसर',
    superBoost: '200% सुपर बूस्ट',
    soundscape: 'अंबिएंट ध्वनि',
    rain: 'बारिश',
    waves: 'समुद्र की लहरें',
    off: 'बंद',
    aspectRatio: 'एस्पेक्ट रेशियो',
    fit169: 'फिट 16:9',
    fillZoom: 'फिल/ज़ूम',
    stretch: 'स्ट्रेच',
    fit43: 'फिट 4:3',
    speed: 'प्लेबैक गति',
    telemetry: 'स्ट्रीम डायग्नोस्टिक्स',
    voiceControl: 'एआई वॉयस कंट्रोल',
    voiceListening: 'कमांड सुन रहा है...',
    voiceInstruction: '"[चैनल] चलाएं" या "बेस बूस्ट ऑन" बोलें',
    parentalPin: 'पेरेंटल पिन',
    enterPin: '4-अंकीय पिन दर्ज करें',
    pinLocked: 'श्रेणी लॉक की गई',
    unlock: 'अनलॉक करें',
    cloudResume: 'पिछला देखा गया चैनल',
    cloudResumePrompt: 'क्या दूसरे डिवाइस से आगे देखना जारी रखें?',
    resume: 'स्ट्रीम जारी रखें',
    dismiss: 'रद्द करें',
    installApp: 'ऐप इंस्टॉल करें',
    pwaPrompt: 'तेज़ और आसान स्ट्रीमिंग के लिए होम स्क्रीन पर जोड़ें',
    upgradePro: 'प्रो में अपग्रेड करें',
    heroTitlePrefix: 'सर्वश्रेष्ठ',
    heroTitleHighlight: 'आईपीटीवी प्लेयर',
    heroTitleSuffix: 'आपके ब्राउज़र के लिए',
    heroTitleLine1: 'सर्वश्रेष्ठ',
    heroTitleLine2: 'आईपीटीवी प्लेयर आपके ब्राउज़र के लिए',
    heroSubtitle: 'बिना किसी इंस्टॉलेशन के तुरंत अपनी M3U प्लेलिस्ट स्ट्रीम करें। सिनेमाई अनुभव, वेब ऑडियो EQ बूस्टर, रीयल-टाइम टेलीमेट्री और 2x2 मल्टी-व्यू ग्रिड सीधे अपने ब्राउज़र में पाएं।',
    ctaOpenLibrary: 'लाइब्रेरी खोलें',
    ctaStartStreaming: 'स्ट्रीमिंग शुरू करें',
    ctaExploreChannels: 'मुफ्त चैनल देखें',
    navFeatures: 'विशेषताएं',
    navHowItWorks: 'यह कैसे काम करता है',
    navFaq: 'सामान्य प्रश्न',
    navGuides: 'गाइड'
  },
  fr: {
    channels: 'Chaînes',
    epg: 'Programme EPG',
    favorites: 'Favoris',
    playlists: 'Playlists Enregistrées',
    multiView: 'Multi-Vue (2x2)',
    singleView: 'Vue Unique',
    searchChannels: 'Rechercher des chaînes...',
    allCategories: 'Toutes les catégories',
    boost: 'Boost Audio',
    eqMode: 'Égaliseur',
    normal: 'Normal (100%)',
    bassBoost: 'Bass Boost (160%)',
    vocalEnhancer: 'Amplificateur Vocal',
    superBoost: '200% Super Boost',
    soundscape: 'Ambiance Sonore',
    rain: 'Pluie',
    waves: 'Vagues de l\'océan',
    off: 'Désactivé',
    aspectRatio: 'Ratio d\'aspect',
    fit169: 'Ajuster 16:9',
    fillZoom: 'Remplir/Zoom',
    stretch: 'Étirer',
    fit43: 'Ajuster 4:3',
    speed: 'Vitesse de lecture',
    telemetry: 'Diagnostic de flux',
    voiceControl: 'Commande Vocale IA',
    voiceListening: 'Écoute des commandes...',
    voiceInstruction: 'Dites "Passer à [Chaîne]" ou "Bass Boost"',
    parentalPin: 'Code PIN Parental',
    enterPin: 'Entrer le code PIN à 4 chiffres',
    pinLocked: 'Catégorie Verrouillée',
    unlock: 'Déverrouiller',
    cloudResume: 'Reprendre la lecture',
    cloudResumePrompt: 'Reprendre là où vous vous étiez arrêté sur un autre appareil ?',
    resume: 'Reprendre',
    dismiss: 'Ignorer',
    installApp: 'Installer l\'application',
    pwaPrompt: 'Installer sur l\'écran d\'accueil pour un streaming natif',
    upgradePro: 'Passer à PRO',
    heroTitlePrefix: 'L\'Ultime',
    heroTitleHighlight: 'Lecteur IPTV',
    heroTitleSuffix: 'pour Votre Navigateur',
    heroTitleLine1: 'L\'Ultime',
    heroTitleLine2: 'Lecteur IPTV pour Votre Navigateur',
    heroSubtitle: 'Lisez vos listes M3U instantanément, sans aucune installation. Profitez d\'une fluidité cinématographique, d\'amplificateurs audio EQ, d\'une télémétrie en temps réel et d\'un affichage multi-vue 2x2 directement dans votre navigateur.',
    ctaOpenLibrary: 'OUVRIR VOTRE BIBLIOTHÈQUE',
    ctaStartStreaming: 'COMMENCER À DIFFUSER',
    ctaExploreChannels: 'EXPLORER LES CHAÎNES GRATUITES',
    navFeatures: 'Fonctionnalités',
    navHowItWorks: 'Comment ça marche',
    navFaq: 'FAQ',
    navGuides: 'Guides'
  },
  de: {
    channels: 'Sender',
    epg: 'EPG Programm',
    favorites: 'Favoriten',
    playlists: 'Bibliothek Playlists',
    multiView: 'Multi-View (2x2)',
    singleView: 'Einzelsender',
    searchChannels: 'Sender suchen...',
    allCategories: 'Alle Kategorien',
    boost: 'Audio Boost',
    eqMode: 'Equalizer-Modus',
    normal: 'Normal (100%)',
    bassBoost: 'Bass Boost (160%)',
    vocalEnhancer: 'Sprachverstärker',
    superBoost: '200% Super Boost',
    soundscape: 'Umgebungsgeräusche',
    rain: 'Regen',
    waves: 'Meereswellen',
    off: 'Aus',
    aspectRatio: 'Seitenverhältnis',
    fit169: 'Anpassen 16:9',
    fillZoom: 'Füllen/Zoom',
    stretch: 'Strecken',
    fit43: 'Anpassen 4:3',
    speed: 'Wiedergabegeschwindigkeit',
    telemetry: 'Stream-Diagnose',
    voiceControl: 'KI-Sprachsteuerung',
    voiceListening: 'Warte auf Befehl...',
    voiceInstruction: 'Sagen Sie "Schalte zu [Sender]" oder "Bass Boost"',
    parentalPin: 'Jugendschutz-PIN',
    enterPin: '4-stellige PIN eingeben',
    pinLocked: 'Kategorie Gesperrt',
    unlock: 'Entsperren',
    cloudResume: 'Wiedergabe fortsetzen',
    cloudResumePrompt: 'Auf anderem Gerät begonnenen Stream fortsetzen?',
    resume: 'Fortsetzen',
    dismiss: 'Schließen',
    installApp: 'App Installieren',
    pwaPrompt: 'Für schnelles Streaming auf dem Startbildschirm installieren',
    upgradePro: 'Auf PRO Upgraden',
    dailyLimitReached: 'Tägliches kostenloses Limit erreicht (10 Min.)',
    heroTitlePrefix: 'Der Ultimative',
    heroTitleHighlight: 'IPTV Player',
    heroTitleSuffix: 'für Ihren Browser',
    heroTitleLine1: 'Der Ultimative',
    heroTitleLine2: 'IPTV Player für Ihren Browser',
    heroSubtitle: 'Streamen Sie Ihre M3U-Wiedergabelisten sofort ohne Installation. Erleben Sie kinoreife Bildqualität, Web-Audio-EQ-Booster, Echtzeit-Telemetrie und ein 2x2-Multi-View-Raster direkt in Ihrem Browser.',
    ctaOpenLibrary: 'BIBLIOTHEK ÖFFNEN',
    ctaStartStreaming: 'JETZT STREAMEN',
    ctaExploreChannels: 'KOSTENLOSE KANÄLE ENTDECKEN',
    navFeatures: 'Funktionen',
    navHowItWorks: 'Wie es funktioniert',
    navFaq: 'FAQ',
    navGuides: 'Anleitungen'
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('appLanguage') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('appLanguage', lang);
  }, [lang]);

  const t = (key) => {
    return TRANSLATIONS[lang]?.[key] || TRANSLATIONS['en']?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
